module.exports = {"id":"21146","name":"Michael Carrick","rating":"79","photo":"./data/images/photos/2/21146.png","club":{"name":"Manchester Utd","logo":"./data/images/clubs/ManchesterUtd.png"},"positions":["MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MichaelCarrick0.json
// module id = 2980
// module chunks = 0